/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-expressions */
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
// import { compose } from 'recompose';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import messages from './LoaderAnswerSheetMessages';

import './LoaderAnswerSheet.scss';

const LoaderAnswerSheet = ({
  show,
  // groupName,
  // currentAnswerSheet,
  // totalAnswerSheet,
  // savingFile,
  ...props
}) => (
  <div>
    <div className={classNames('loading-text-custom', { show })}>
      {/* <p>{intl.formatMessage(messages.processing)}</p>
      <p>{intl.formatMessage(messages.pleaseWait)}</p> */}
      <p>
        <FormattedMessage {...messages.processing} />
      </p>
      <p>
        <FormattedMessage {...messages.pleaseWait} />
      </p>

      {/* <p>
        Processando turma: <span>{groupName}</span>
      </p>
      <p>
        Processando cartão-resposta: <span>{currentAnswerSheet}</span>/
        <span>{totalAnswerSheet}</span>
      </p>
      {savingFile && <p>Salvando arquivo...</p>} */}
    </div>

    <div
      {...props}
      className={classNames('loading', {
        show,
      })}
    />
  </div>
);

LoaderAnswerSheet.propTypes = {
  show: PropTypes.bool,
  // groupName: PropTypes.string,
  // currentAnswerSheet: PropTypes.string,
  // totalAnswerSheet: PropTypes.string,
  // savingFile: PropTypes.bool,
};

LoaderAnswerSheet.defaultProps = {
  show: false,
  // groupName: '',
  // savingFile: false,
};

export default LoaderAnswerSheet;

// export default compose(injectIntl)(LoaderAnswerSheet);
